module.exports = __webpack_public_path__ + "img/insta-14.8a0107e7.jpg";